import Prism from 'prismjs';
import 'prismjs/components/prism-json';

import getSymbolFromCurrency from 'currency-symbol-map';

export function stringToNumber(string = '') {
  const formattedString = string.toString().replace(/[,$]/g, '');
  return parseFloat(formattedString);
}

export function trimMoney(amount = '', currencyCode) {
  if (amount) {
    let symbol = '';
    if (currencyCode) {
      symbol = getSymbolFromCurrency(currencyCode);
    }
    // add in separator
    return symbol + stringToNumber(amount).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  }

  return amount;
}

export function truncate(string, numChars) {
  if (string && numChars && (string.length > numChars)) {
    const strToAppend = '...';
    const endCutoff = numChars - strToAppend.length;

    return `${string.substring(0, endCutoff).trim()}${strToAppend}`;
  }

  return string;
}

export function stripTrackingDetailMessage(string, carrier) {
  if (carrier !== 'USPS') return string;

  const matches = string.match(/^([A-Za-z]+\s+[0-9]+\s*([0-9:]+\s*[ap]m)?)\s+(.*?)(\sin\s[A-Z, ]+)?$/);

  return matches && matches[3] ? matches[3] : string;
}

export function prismFormatJSON(object) {
  return Prism.highlight(JSON.stringify(object, null, 2), Prism.languages.json);
}

export function formatPhone(phoneNumber) {
  if (!phoneNumber) {
    return '';
  }
  if (phoneNumber.length !== 10) {
    return phoneNumber;
  }
  return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
}



// WEBPACK FOOTER //
// ./utils/strings.js